import { cf2imgix } from '@uswitch/ev-components/lib/components/elements/imgix-img'
import React, { useEffect } from 'react'

import { Underline } from '~/assets/images'
import { track, trackSegment } from '~/utils/tracking'

import styles from './styles.module.css'
import { useVirginMediaBannerLink, TrackingArgs } from './utils'

const BANNER_TITLE = 'Exclusive offer for Virgin Media customers'

const LOGO_HEIGHT = 55
const ROUTER_IMAGE_HEIGHT = 216
const VIRGIN_MEDIA_LOGO_URL = cf2imgix(
  `//images.ctfassets.net/n36b8lzdmgnp/6Qw8Hww3ZZ96a5zwu3NHzX/a59ab484c0077d632c0bb09b7924fbab/virgin-media-logo-mono.png?h=${LOGO_HEIGHT}`
)
const VIRGIN_MEDIA_ROTUER_IMAGE_URL = cf2imgix(
  `//images.ctfassets.net/n36b8lzdmgnp/4oFcGec1tfWW72P4i2ZFKQ/bc3363007ad2e267a3bfb94ec000434b/virgin-media-router.png?h=${ROUTER_IMAGE_HEIGHT}`
)

interface Props {
  visibility: boolean
  trackingProps: TrackingArgs
}

const VirginMediaMessage = ({ visibility, trackingProps }: Props) => {
  const href = useVirginMediaBannerLink({ ...trackingProps, title: BANNER_TITLE })

  useEffect(() => {
    if (visibility) {
      track('Broadband - Virgin Media returning customer message', 'Virgin Media returning customer banner shown')

      trackSegment('Element Viewed', {
        element_name: 'Virgin Media banner',
        element_type: 'link',
        org_brand: 'uswitch'
      })
    }
  }, [visibility])

  if (!visibility) {
    return <></>
  }

  const handleClick = () => {
    track('Broadband - Virgin Media returning customer message', 'Virgin Media returning customer banner clicked')
    trackSegment('Element Clicked', {
      element_name: 'Virgin Media banner',
      element_text: 'Virgin Media banner',
      element_type: 'link'
    })
  }

  return (
    <a className={styles.wrapper} onClick={handleClick} href={href} target='_blank' rel='noreferrer'>
      <div className={styles.content}>
        <div className={styles.titleRow}>
          <h6 className={styles.title}>{BANNER_TITLE}</h6>
          <Underline className={styles.underline} />
        </div>

        <div className={styles.text}>
          Get a free speed boost and locked in prices for 2023 when you renew your contract.
        </div>

        <div className={styles.button}>View your offer</div>
      </div>

      <div className={styles.imagesWrapper}>
        <img alt='Virgin Media logo' className={styles.logo} src={VIRGIN_MEDIA_LOGO_URL} />

        <img alt='Virgin Media router' className={styles.routerImage} src={VIRGIN_MEDIA_ROTUER_IMAGE_URL} />
      </div>
    </a>
  )
}

export default VirginMediaMessage
